<template>
  <TemplateConMenuLateral>
    <Banner slot="banner" :titulo="titulo" style="flex: 1 0 100%" />
    <div slot="menu" class="menucontextual">
      <SeccionOcultable titulo="Documentación" v-if="hasDocumentacion">
        <ul>
          <li v-for="itemDocumento in siniestro.documentosSiniestro" :key="'d' + itemDocumento.uuid">
            <a href="#" target="_blank" class="ripple" @click.prevent="downloadDocumento(itemDocumento.uuid)">
              {{ itemDocumento.nombreDoc }}
              <br />
              <label class="fechaFirma">
                {{ labelDocumento(itemDocumento) }}
                {{ itemDocumento.fechaFirma | dateDDMMYYYY }}
              </label>
            </a>
          </li>
        </ul>
      </SeccionOcultable>
    </div>

    <div v-if="siniestro.numSiniestro" slot="contenido" class="tarjetario">
      <TarjetaDatos titulo="Datos Generales" tipo="naranja">
        <Campo2L :valor="siniestro.numPoliza" etiqueta="Póliza" />
        <Campo2L :valor="siniestro.riesgo" etiqueta="Riesgo:" />
        <Campo2L :valor="siniestro.fecOcurrencia | dateDDMMYYYY" etiqueta="Fecha Siniestro: " />
        <Campo2L :valor="siniestro.fecApertura | dateDDMMYYYY" etiqueta="Fecha Comunicación: " />
        <Campo2L :valor="siniestro.estado" etiqueta="Estado" />
        <Campo2L :valor="siniestro.tipo" etiqueta="Tipo" />
      </TarjetaDatos>
      <Historial :siniestro="siniestro" style="flex: 0 1 100%" />
    </div>
  </TemplateConMenuLateral>
</template>

<script>
export default {
  computed: {
    siniestro() {
      return this.$store.state.seleccion;
    },
    titulo() {
      return "Siniestro: " + this.siniestro.nsg("numSiniestro");
    },
    hasDocumentacion() {
      return this.siniestro.nsg("documentosSiniestro.length");
    },
  },

  methods: {
    downloadDocumento: async function (uuid) {
      this.$store.dispatch("dowloadDocumento", uuid);
    },
    labelDocumento(doc) {
      let etiq;
      if (doc.aceptado) etiq = "Firmado el ";
      else etiq = "Rechazado el ";
      return etiq;
    },
  },

  beforeRouteEnter: async function (to, from, next) {
    await fetchData(to.params.numSiniestro);
    next();
  },

  beforeRouteUpdate: async function (to, from, next) {
    await fetchData(to.params.numSiniestro);
    next();
  },
};

import store from "@/store/store.js";
async function fetchData(numSiniestro) {
  await store.dispatch("getSiniestroMovilidad", numSiniestro);
}
</script>

<style lang="scss" scoped>
.fechaFirma {
  font-size: 85%;
  color: darkgrey;
}
</style>
